import { render } from "./RedesSociales.vue?vue&type=template&id=4816de74&scoped=true"
import script from "./RedesSociales.vue?vue&type=script&lang=js"
export * from "./RedesSociales.vue?vue&type=script&lang=js"

import "./RedesSociales.vue?vue&type=style&index=0&id=4816de74&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4816de74"]])

export default __exports__